export const MENSTRUAL_CYCLE_STATUS = {
  REGULAR: 'regular',
  IRREGULAR: 'irregular',
};
